module.exports = __webpack_public_path__ + "img/Maurice.552f2322.jpg";